import { ContractCommitmentCriteriaTemplate } from '@core/models/contract-commitment-criteria-template.model';
import { ContractCommitment } from '@core/models/contract-commitment.model';

export interface JsonContractCommitmentCriteria {
  id?: number;
  value?: number;
  value2?: number;
  contractItemId?: number;
  datetimeValue?: {
    date: string;
    timezone?: string;
    timezone_type?: number
  };
  template?: ContractCommitmentCriteriaTemplate;
}

export class ContractCommitmentCriteria {
  id: number;
  value: number;
  value2: number;
  contractItemId: number;
  datetimeValue?: {
    date: string;
    timezone?: string;
    timezone_type?: number
  };
  template?: ContractCommitmentCriteriaTemplate;

  constructor(jsonContractCommitmentCriteria: JsonContractCommitmentCriteria = null) {
    this.id = jsonContractCommitmentCriteria.id;
    this.value = jsonContractCommitmentCriteria.value;
    this.value2 = jsonContractCommitmentCriteria.value2;
    this.contractItemId = jsonContractCommitmentCriteria.contractItemId;
    this.datetimeValue = jsonContractCommitmentCriteria.datetimeValue;
    this.template = jsonContractCommitmentCriteria.template ? jsonContractCommitmentCriteria.template : null;
  }
}

export interface JsonContractCommitmentCriteriaImmutable {
  id?: number;
  value?: number;
  value2?: number;
  contractItemId?: number;
  datetimeValue?: {
    date: string;
    timezone?: string;
    timezone_type?: number
  };
  template?: ContractCommitmentCriteriaTemplate;

}

export class ContractCommitmentCriteriaImmutable {
  id: number;
  value: number;
  value2: number;
  contractItemId: number;
  datetimeValue?: {
    date: string;
    timezone?: string;
    timezone_type?: number
  };
  template?: ContractCommitmentCriteriaTemplate;

  constructor(jsonContractCommitmentImmutable: JsonContractCommitmentCriteria = null) {
    this.id = jsonContractCommitmentImmutable.id;
    this.value = jsonContractCommitmentImmutable.value;
    this.value2 = jsonContractCommitmentImmutable.value2;
    this.contractItemId = jsonContractCommitmentImmutable.contractItemId;
    this.datetimeValue = jsonContractCommitmentImmutable.datetimeValue;
    this.template = jsonContractCommitmentImmutable.template ? jsonContractCommitmentImmutable.template : null;
  }
}

export class CommitmentCriteriaFormGroup {
  category: string;
  commitmentCriterias: ContractCommitmentCriteria[]
}
